export default __webpack_public_path__ + "static/color-picker-text-light-6d0f37b8788d28c502de1c8f7db696dc60a13fcbe45bd159163f6e6c855040d7.png";